import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import { useNavigate } from "react-router-dom";
import { validationMessages } from "../../utils/messages";
import { regExPattern } from "../../utils/regExPattern";
import { useEffect } from "react";
import Select from "react-select";
import { useLocation } from "react-router-dom";

// Define initial errors i.e. required field and their message
const initialErrors = {
  sub_category_name: { message: validationMessages.subCategoryName.required },
};

const SubCategoryEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const [category, setCategory] = useState(props?.category ? props.category : {})
  //   const [category, setCategory] = useState(location?.state ? location?.state : {});
  //   const [product, setProduct] = useState(location?.state ? location?.state : {});
  const [optionCategory, setOptionCategory] = useState({});
  const [selectedCategory, setSelectedCategory] = useState();

  //errors state
  const [errors, setErrors] = useState(!props.category ? initialErrors : {});
  const navigate = useNavigate();

  useEffect(() => {
    if (!category.id) {
      //   setCategory({ ...category, isactive : false});
    }
  }, [])


  useEffect(() => {
    async function init() {
      const fetchCategories = await trasportApi.fetchAllCategory();

      if (fetchCategories) {
        let categoryOptions = fetchCategories.map((item) => ({
          value: item.id,
          label: item.name,
          contact: item,
        }));
        setOptionCategory(categoryOptions);
        if (props?.category?.category_id) {
          let category = categoryOptions.filter(
            (category) => category.value === props.category.category_id
          );
          setSelectedCategory(category);
        }
      } else {
        setOptionCategory([]);
      }
    }
    init();
  }, []);

  const checkRequiredFields = () => {

    if(!category.category_id){
      setErrors((prev) => ({ ...prev, 'category_name': { message: validationMessages.categoryName.required } }));
      return true
    }
    if (
      category.sub_category_name &&
      category.sub_category_name.trim() !== ""
    ) {

      return false;
    }

    let isError = false;

    // handle errors for required fields
    if (!category?.sub_category_name) {
      setErrors((prev) => ({ ...prev, 'sub_category_name': { message: validationMessages.subCategoryName.required } }));
      isError = true;
    }
    return isError;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();


    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    if (Object?.keys(errors)?.length != 0) {
      console.log("Object?.keys(errors)?.length", Object?.keys(errors)?.length);
      setValidated(true);
      return;
    }
    let result2 = {};

    if (category.id) {
      result2 = await trasportApi.saveSubCategories(category);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      result2 = await trasportApi.createSubCategory(category);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }
    props.submitCategoryList();
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name == "sub_category_name") {
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.subCategoryName.required } }));
      } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.subCategoryName.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    setValidated(true);
    setCategory((prev) => ({ ...prev, [name]: value }));
  };


  //Category Handler Change
  const handleCategory = (e) => {
    console.log("Event on Contact", e.contact);
    const name = "category_name"; // set manually since react-select doesn't give this
    const value = e?.value;


    if (name === "category_name") {
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.categoryName.required } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    setValidated(true);
    setSelectedCategory(e);

    //Added By Farhan Khan on 02-March-2025 Using for Generate SKU using product name and category label
    // const generatedSKU = product.product_name
    //   ? `${product.product_name}-${e.label}`.replace(/\s+/g, "-").toUpperCase()
    //   : "";

    //   const generatedSKU =
    //   product.product_name && e.label
    //     ? `${product.product_name.slice(0, 3)}-${e.label
    //         .split(" ")
    //         .filter(Boolean)
    //         .map((word) => word.slice(0, 3))
    //         .join("-")}`.toUpperCase()
    //     : "";

    //   if (!product.id) {
    //     console.log("State =>", product);
    //     setProduct({...product, category_id: e.value, 
    //     });
    //   } else {
    setCategory({ ...category, category_id: e.value });
    //   }
  };

  return (
    <Modal {...props} size="lg" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Sub Category
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                noValidate
                validated={validated}
              >
                <Row>


                  <Col lg={6} className="mt-2">
                    <Form.Group className="mx-3" >
                      <Form.Label
                        className="form-view-label mt-2"
                        htmlFor="formBasicFirstName"
                      >
                        Category Name
                      </Form.Label>
                      <Select
                        required
                        className={category.category_id ? 'custom-select-valid' : 'custom-select-invalid'}
                        placeholder="Select Category"
                        onChange={handleCategory}
                        options={optionCategory}
                        value={selectedCategory}
                      // isDisabled={!category.product_name}
                      ></Select>
                      {(errors?.category_name?.message && (!category.category_name)) && <div className="feedback-invalid">
                        {errors?.category_name?.message}
                      </div>}
                    </Form.Group>
                  </Col>
                  {console.log("errors?.category_name?.message == ",errors?.category_name?.message)}
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">Sub Category Name</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="sub_category_name"
                        pattern={regExPattern.name}
                        placeholder="Enter Sub Category Name"
                        value={category.sub_category_name}
                        onChange={handleChange}
                        style={{ height: "38px" }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.sub_category_name?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light" className="btn-delete">
          Cancel
        </Button>
        <Button variant="primary" className="btn-edit" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default SubCategoryEdit;
